import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { api } from "../../lib/api";
import { Input } from "../ui/input";
import { todayISO } from "./kitchenUtils";

// Pick a day, tick orders, then print individual sheets and/or the combined day sheet.
export const PrepTab = () => {
  const [day, setDay] = useState(todayISO());
  const [data, setData] = useState(null);
  const [picked, setPicked] = useState(new Set());

  useEffect(() => {
    let alive = true;
    setData(null);
    api.get("/admin/kitchen/prep", { params: { date: day } })
      .then((r) => {
        if (!alive) return;
        setData(r.data);
        setPicked(new Set(r.data.orders.map((o) => o.sheet_key)));
      })
      .catch(() => alive && setData({ orders: [] }));
    return () => { alive = false; };
  }, [day]);

  const toggle = (id) => setPicked((s) => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });
  const ids = [...picked].join(",");
  const btn = "h-11 px-4 rounded-full text-[11.5px] font-bold uppercase tracking-[0.1em] inline-flex items-center gap-2";
  return (
    <div className="space-y-3" data-testid="prep-tab">
      <div className="flex flex-wrap items-center gap-2">
        <Input type="date" value={day} onChange={(e) => setDay(e.target.value)} data-testid="prep-date" className="h-11 w-48 rounded-full bg-white border-black/10" />
        {data && data.orders.length > 0 && (
          <>
            <Link to={`/admin/kitchen/print?date=${day}&mode=orders&ids=${ids}`} target="_blank" data-testid="prep-print-orders"
              className={`${btn} bg-brand-charcoal text-white ${picked.size ? "" : "pointer-events-none opacity-50"}`}>
              <Printer className="h-4 w-4" /> Print {picked.size} order sheet{picked.size === 1 ? "" : "s"}
            </Link>
            <Link to={`/admin/kitchen/print?date=${day}&mode=combined&ids=${ids}`} target="_blank" data-testid="prep-print-combined"
              className={`${btn} bg-brand-teal text-white ${picked.size ? "" : "pointer-events-none opacity-50"}`}>
              <Printer className="h-4 w-4" /> Print combined day sheet
            </Link>
          </>
        )}
      </div>
      {!data && <Loader2 className="h-5 w-5 animate-spin text-brand-teal" />}
      {data?.orders.length === 0 && <p className="text-[13px] text-brand-charcoal/55" data-testid="prep-empty">No orders on this day.</p>}
      <div className="grid gap-2">
        {data?.orders.map((o) => (
          <label key={o.sheet_key} data-testid={`prep-order-${o.sheet_key}`} className="flex items-center gap-3 rounded-xl bg-white border border-black/10 px-4 py-2.5 cursor-pointer">
            <input type="checkbox" checked={picked.has(o.sheet_key)} onChange={() => toggle(o.sheet_key)} data-testid={`prep-order-check-${o.sheet_key}`} className="h-5 w-5 accent-brand-teal" />
            <div className="min-w-0 flex-1">
              <p className="font-bold text-[14px] text-brand-charcoal truncate">{o.organization || o.customer_name} <span className="font-normal text-brand-charcoal/50 text-[12px]">{o.invoice_number || o.order_number || ""}</span></p>
              <p className="text-[12px] text-brand-charcoal/60">{o.event_time || "Time TBD"} · {o.fulfillment} · {o.lines.length} item{o.lines.length === 1 ? "" : "s"} · {o.status.replace(/_/g, " ")}</p>
            </div>
            {o.missing_recipes.length > 0 && <span className="text-[10.5px] font-bold text-brand-gold-dark shrink-0">{o.missing_recipes.length} without recipe</span>}
          </label>
        ))}
      </div>
    </div>
  );
};

export default PrepTab;
